<script>
    import f9select2 from "shared/Components/Inputs/f9select2.vue";
    import f9button2 from "shared/Components/Inputs/f9button2.vue";
    import f9field2 from "shared/Components/Inputs/f9field2.vue";
    import BagPriceGrid from "./BagPriceGrid.vue";

    export default {
        props: {
            isExisting: {
                type: Boolean,
                default: true
            },
            origin: {
                type: String,
                default: null
            },
            destination: {
                type: String,
                default: null
            },
            flightData: {//data to populate flight select dropdowns
                type: Object,
                default: null
            },
            priceData: {//data to populate grid
                type: Object,
                default: null
            },
            doneSearching: {
                type: Boolean,
                default: false
            },
            isExisting: Boolean,
            roundTrip: Boolean
        },
        data() {
            return {
                searching: false,
                searchChanged: false,
                departureFlight: null,
                returnFlight: null,
                flightUnavailable: false,
                errorMessage:"",
                priceArray: null,
                disabledColumns: null,
            };
        },
        computed: {
            departFlights() {
                if(this.flightData && this.flightData.departureTimes && 
                    this.flightData.departureTimes.length > 0) {
                    return this.flightData.departureTimes.map(data => ({
                        text: data.displayTime,
                        value: data.key
                    }))
                } 
                return [{text: "No Flights Available", value: ""}];
            },
            returnFlights() {
                if(this.flightData && this.flightData.returnTimes) {
                    return this.flightData.returnTimes.map(data => ({
                        text: data.displayTime,
                        value: data.key
                    }))
                }
                return [{text: "No Flights Available", value: ""}];
            },
            disableButton() {
                let departSelected = !!this.departureFlight,
                    returnSelected = !!this.returnFlight;
                
                if(!this.returnFlights) {
                    return !departSelected;
                }

                return !departSelected || !returnSelected;
            }
        },
        methods: {
            selectFlights() {
                this.validate().then(result => {
                    if(result) {
                        this.searching = true;
                        this.searchChanged = false;
                        this.$emit("select", {
                            departureFlight: this.departureFlight,
                            returnFlight: this.returnFlight
                        });
                    }
                })
            }
        },
        watch: {
            priceData: {
                deep: true,
                handler(val) {
                    if(val) {
                        this.flightUnavailable = val.flightUnavailable;
                        this.errorMessage = val.errorMessage;

                        if(!val.flightUnavailable) {
                            setTimeout(() => this.$refs.grid.$el.scrollIntoView({ behavior: "smooth" }), 500);
                        } else {
                            setTimeout(() => this.$refs.unavailable.scrollIntoView({ behavior: "smooth" }), 500);
                        }

                        this.priceArray = val.priceData;
                        this.disabledColumns = val.disabledColumns;
                    } else {
                        this.priceArray = null;
                        this.flightUnavailable = false;
                        this.errorMessage = "";
                    }
                }
            },
            flightData: {
                deep: true,
                handler(val) {
                    if(val) {
                        this.$nextTick(() => {
                            this.$el.scrollIntoView({ behavior: "smooth" })

                            if(this.departFlights && this.departFlights.length > 0) {
                                this.departureFlight = this.departFlights[0].value;
                            }
                            
                            if(this.returnFlights && this.returnFlights.length > 0) {
                                this.returnFlight = this.returnFlights[0].value;
                            }
                        });
                    }
                }
            },
            doneSearching(val) {
                if(val) {
                    this.searching = false;
                }
            },
            departureFlight() {
                this.searchChanged = true;
            },
            returnFlight() {
                this.searchChanged = true;
            }
        },
        components: {
            f9select2,
            f9button2,
            f9field2,
            BagPriceGrid
        }
    }
</script>

<template>
    <div class="flight-select-container">
        <div v-show="flightData" class="flight-select">
            <div class="flight-select-header">View bag prices for:</div>
            <div class="flight-select-dropdowns">
                <f9field2 class="flight-select-route" :label="'Departure Time (' + origin + ' &gt; ' + destination +')'" 
                    v-if="departFlights && departFlights.length">
                    <f9select2 name="depart_time" v-validate="'required'" v-model="departureFlight" :items="departFlights"></f9select2>
                </f9field2>
                <f9field2 class="flight-select-route"  :label="'Return Time (' + destination + ' &gt; ' + origin +')'" 
                    v-if="roundTrip && returnFlights && returnFlights.length">
                    <f9select2 name="return_time" v-validate="'required'" v-model="returnFlight" :items="returnFlights"></f9select2>
                </f9field2>
                <f9button2 class="flight-select-search" :loading="searching" @click="selectFlights">Search</f9button2>
            </div>
        </div>
        <div ref="unavailable" class="flight-unavailable-container" :class="{ noheight: !flightUnavailable }">
            <div class="flight-unavailable">
                <div v-show="errorMessage" class="flight-unavailable-errorMessage">{{errorMessage}}</div>
                <div v-show="!errorMessage" class="flight-unavailable-header">Please select another<span class="hide-md hide-sm">&nbsp;flight</span></div>
                <div v-show="!errorMessage" class="flight-unavailable-sub">One or more of your selected flights is not available. </div>
            </div>
        </div>
        <bag-price-grid ref="grid" class="flight-select-grid" :price-data="priceArray" :is-existing="isExisting" :disabledColumns="disabledColumns"
            :class="{ noheight: !priceArray || searchChanged || flightUnavailable }">
        </bag-price-grid>
        <div class="footer-info" :class="{ noheight: !priceArray || searchChanged || flightUnavailable }">
            <div class="peronal-item-info">
                <b>1 Personal item is included</b>
            </div>
            <div class="t-and-c-text">
                *All prices are per person, per direction. Prices are valid for this browser session ONLY. To lock in these prices, you must complete your booking before your session expires. If you did not complete all sections of this form, or your actual booking varies from the information you provided, then your prices may be different from those listed above. In some instances, a government tax may be applied to your baggage price, which will be reflected in the total price quoted to you before you book. Active duty military passengers, subject to verification, may bring one carry-on bag and/or may check up to two bags, which may be oversized and/or overweight, for free. This benefit does not extend to family members or other traveling companions.
            </div>
            <div class="t-and-c-service-charge">A service charge of up to $25 per person per direction applies to all agent assisted transactions.</div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .flight-select-container {
        width: 1094px;
        max-width: 100vw;
        background-color: @frontier-gray-lightest;
        margin-top: 26px;
        padding: 24px 28px;

        .noheight {
            border: none !important;
            max-height: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
        }

        .flight-select {
            display: flex;
            flex-direction: column;
            margin-bottom: 25px;

            .flight-select-header {
                color: @frontier-gray-xxdark;
                font-size: 18px;
                font-weight: 600;
                line-height: 24px;
                text-transform: uppercase;
            }
            
            .flight-select-dropdowns {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                margin-top: 10px;

                .flight-select-route {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    width: 301px;
                    margin-right: 15px;
                    margin-top: 0;

                    @{deep} {
                        .slider-label {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 14px;
                            color: @ibe-text--gray;
                            margin-bottom: 5px;
                        }
                    }
                }

                .flight-select-search {
                    margin-top: 16px;
                }
            }
        }

        .flight-unavailable-container {
            .flight-unavailable {
                border: 1px solid @ibe-background--red;
                color: @ibe-text--dark-gray;
                font-size: 12px;
                line-height: 12px;
                font-weight: 400;
                margin-top: 11px;
                height: auto;
                overflow: hidden;
                max-height: 1000vh;
                transition: max-height 2s;
                padding: 11px 14px;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                
                .flight-unavailable-header {
                    font-size: 16px;
                    line-height: 16px;
                    font-weight: 600;
                    text-transform: uppercase;
                    color: @ibe-text--red;
                    margin-bottom: 6px;
                }
                .flight-unavailable-errorMessage{
                     color: @ibe-text--red;
                }
            }
        }

        .flight-select-grid {
            height: auto;
            overflow: hidden;
            max-height: 1000vh;
            transition: max-height 2s;
        }

        .footer-info {
            color: #6d6d6d;
            font-weight: 400;
            line-height: 15px;
            margin-top: 24px;
            padding: 0 18px;

            .peronal-item-info {
                font-size: 12px;

                b {
                    font-weight: 600;
                }
            }

            .t-and-c-text {
                margin-top: 11px;
                font-size: 11px;
            }

            .t-and-c-service-charge {
                font-size: 11px;
                font-style: italic; 
            }
        }
    }

    @media @tablet-lg {
        .flight-select-container {
            width: 100vw;
            padding: 15px 0 15px 15px;

            .flight-select {
                .flight-select-header {
                    font-size: 16px;
                    line-height: 24px;
                }
            }

            .footer-info {
                padding: 0;
            }
        }
    }

    @media @tablet {
        .flight-select-container {
            margin-top: 20px;
            padding: 16px 14px;

            .flight-select {
                padding-top: 15px;
                padding: 15px 16px 0 16px;

                .flight-select-dropdowns {
                    margin-top: 6px;
                    flex-direction: column;
                    
                    .flight-select-route {
                        margin-right: 0;
                        width: 100%;

                        &:not(:first-of-type) {
                            margin-top: 14px;
                        }
                        
                        @{deep} {
                            .slider-label {
                                padding-left: 3px;
                            }
                        }
                    }
                }
            }
            
            .flight-unavailable-container {
                padding: 0 16px;

                .flight-unavailable {
                    margin-top: 19px;
                    padding: 14px;
                }
            }

            .flight-select-grid {
                width: calc(~"100vw - 14px");
            }
        }
    }
</style>